module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat1@2x-5f57c42cb1035fad5a97e59dad52ad63.jpg";